// extracted by mini-css-extract-plugin
module.exports = {"birthday-select":"DateFormField_birthday-select__oX0Lb"};